

export const Statuses = {
    0: 'Чакащо класиране',
    1: 'Класиранo',
    2: 'Анулирано заявление преди класиране',
    3: 'Навършило години',
    4: 'Записано',
    5: 'Отпаднало - потвърдило но незаписало',
    6: 'Записано отпреди',
    7: 'Потвърдено',
    8: 'Непотвърден в срок',
    9: 'Отказано',
    10: 'Отписано'
}

export const SedGroupsCodes = {
    1: 'K210',
    2: 'K220',
    3: 'K230',
    4: 'K240',
}
